var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKafkaWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160696",
    "data-name": "Group 160696",
    transform: "translate(-136 -320)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1345",
    "data-name": "Rectangle 1345",
    width: 18,
    height: 18,
    transform: "translate(136 320)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160629",
    "data-name": "Group 160629",
    transform: "translate(137.118 320.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160600",
    "data-name": "Group 160600",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160599",
    "data-name": "Group 160599",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    width: 15.658,
    height: 14.539,
    transform: "translate(0 1.014)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4528",
    "data-name": "Group 4528",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1334",
    "data-name": "Rectangle 1334",
    width: 15.658,
    height: 14.539,
    transform: "translate(0 1.014)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_198",
    transform: "translate(3.764)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    cx: 2.032,
    cy: 2.032,
    r: 2.032,
    transform: "translate(0)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_198-2",
    "data-name": "Ellipse 198",
    cx: 1.524,
    cy: 1.524,
    r: 1.524,
    transform: "translate(0.508 0.508)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    cx: 2.71,
    cy: 2.71,
    r: 2.71,
    transform: "translate(3.268 5.251)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M5.389,9.16a2.2,2.2,0,1,1-.129,2.547",
    transform: "translate(-1.139 -2.561)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_199-2",
    "data-name": "Ellipse_199",
    transform: "translate(9.257 2.879)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 2.032,
    cy: 2.032,
    r: 2.032,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_201",
    "data-name": "Ellipse 201",
    cx: 1.524,
    cy: 1.524,
    r: 1.524,
    transform: "translate(0.508 0.508)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_201-2",
    "data-name": "Ellipse_201",
    transform: "translate(9.257 8.977)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    cx: 2.032,
    cy: 2.032,
    r: 2.032,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_203",
    "data-name": "Ellipse 203",
    cx: 1.524,
    cy: 1.524,
    r: 1.524,
    transform: "translate(0.508 0.508)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_200-2",
    "data-name": "Ellipse_200",
    transform: "translate(3.764 11.991)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    cx: 2.032,
    cy: 2.032,
    r: 2.032,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205",
    "data-name": "Ellipse 205",
    cx: 1.524,
    cy: 1.524,
    r: 1.524,
    transform: "translate(0.508 0.508)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_135",
    "data-name": "Line 135",
    y2: 1.694,
    transform: "translate(5.977 4.065)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_136",
    "data-name": "Line 136",
    y2: 1.694,
    transform: "translate(5.977 10.162)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_137",
    "data-name": "Line 137",
    x1: 1.402,
    y2: 0.948,
    transform: "translate(7.854 5.914)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_138",
    "data-name": "Line 138",
    x2: 1.402,
    y2: 0.948,
    transform: "translate(7.854 8.984)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    cx: 0.386,
    cy: 0.386,
    r: 0.386,
    transform: "translate(3.389 7.574)",
    fill: "#787f88"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKafkaWhiteIcon);
export default __webpack_public_path__ + "static/media/kafka-white-icon.55c70df2505a46d17277b8437625db19.svg";
export { ForwardRef as ReactComponent };